import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

export type CancelConfirmModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirmCancel: () => void;
  content?: string;
};

export function CancelConfirmModal({
  open,
  onClose,
  onConfirmCancel,
  content = 'You have unsaved changes. Do you want to abandon these edits?',
}: Readonly<CancelConfirmModalProps>) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      data-testid="policy-cancel-confirm-modal"
      sx={{
        '& .MuiDialog-paper': { maxWidth: 720 },
        '& .MuiDialogTitle-root + .MuiDialogContent-root': { pt: 3 },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 3,
          py: 2,
          borderBottom: '1px dashed',
          borderColor: 'divider',
        }}
      >
        Cancel pending edits
        <IconButton onClick={onClose} aria-label="close" data-testid="policy-cancel-confirm-close" size="small" sx={{ color: 'text.secondary' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 3, pt: 3, pb: 0 }}>
        <Typography variant="body2">{content}</Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'space-between',
          px: 3,
          pb: 3,
          pt: 2,
          borderTop: '1px dashed',
          borderColor: 'divider',
        }}
      >
        <Button onClick={onClose} variant="outlined" color="inherit" data-testid="policy-cancel-confirm-no-go-back">
          No, go back
        </Button>
        <Button
          variant="contained"
          color="inherit"
          onClick={onConfirmCancel}
          data-testid="policy-cancel-confirm-yes-cancel"
          sx={{ bgcolor: 'grey.800', color: 'common.white', '&:hover': { bgcolor: 'grey.700' } }}
        >
          Yes, cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
